// Google Analytics 4: solo para saber cuánta gente entra al portal y por dónde
// llega (Google, WhatsApp, Facebook, enlaces de otras webs, directo).
//
// Nunca se le manda nada del postor —correo, RUC, documentos, búsquedas—: aquí
// solo se carga la medición de visitas que trae GA4 por defecto.
//
// El identificador va en REACT_APP_GA_ID (archivo .env y variables de entorno
// del hosting). Sin esa variable no se carga ningún script: en desarrollo, y en
// cualquier despliegue donde no esté puesta, la app queda sin medición.

const GA_ID = process.env.REACT_APP_GA_ID;

export const iniciarAnalytics = () => {
  if (!GA_ID || typeof window === 'undefined' || window.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
};
